import React, { useMemo } from "react";

const SurveyTextArea = ({ id, setAnswersList, answersList }) => {
  const answerIdx = useMemo(
    () => answersList.findIndex((item) => item.questionId === id),
    [answersList, id]
  );

  const answer = useMemo(
    () =>
      answerIdx >= 0 ? answersList[answerIdx].answers[0].description : null,
    [answerIdx, answersList]
  );

  const saveAnswer = (description) => {
    if (answerIdx === -1) {
      let newScreenAnswersList = answersList;
      newScreenAnswersList.push({
        answers: [
          {
            description: description,
          },
        ],
        questionId: id,
      });

      setAnswersList([...newScreenAnswersList]);
    } else {
      let newScreenAnswersList = answersList;
      newScreenAnswersList[answerIdx] = {
        answers: [
          {
            description: description,
          },
        ],
        questionId: id,
      };

      setAnswersList([...newScreenAnswersList]);
    }
  };

  return (
    <>
      <textarea
        id={`txtarea-${id}`}
        className="additional-txtarea"
        placeholder="당신의 의견을 기록해주세요."
        value={answer ? answer : ""}
        onChange={(e) => saveAnswer(e.target.value)}
      />
    </>
  );
};

export default SurveyTextArea;
